/**
 * @see https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
 * Fallback for browsers that don't support the Clipboard API
 * Note: document.execCommand is deprecated but still widely supported as fallback
 */
const fallbackCopyTextToClipboard = (text: string): void => {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    // document.execCommand is deprecated but still works as fallback
    document.execCommand('copy');
  } catch {
  } finally {
    document.body.removeChild(textArea);
  }
};

const copyTextToClipboard = async (text: string): Promise<void> => {
  // Try modern Clipboard API first (requires secure context - HTTPS or localhost)
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // If clipboard API fails, fall back to execCommand
      // This can happen if clipboard API is blocked by permissions
    }
  }

  // Fallback to execCommand for older browsers or when clipboard API is unavailable
  fallbackCopyTextToClipboard(text);
};

export default copyTextToClipboard;
